export enum EInputColor {
  Light = 'light',
  Dark = 'dark',
}
